import Accordion, { AccordionProps } from 'components/elements/Accordion/Accordion'
import React, { useEffect } from 'react'
import styles from './AccordionGroup.module.scss'
import { Heading } from '~elements'
import { Container } from 'react-grid-system'
import { useWindowSize } from 'utils/hooks'
import { useSmoothAnchorScroll } from 'utils/hooks/useSmoothAnchorScroll'

interface AccordionGroupProps {
  headline?: string
  accordions: AccordionProps[]
  anchorId?: string
}

const AccordionGroup = ({ headline, accordions, anchorId }: AccordionGroupProps) => {
  const { isBreakpoint: isBelowBreakpointSm } = useWindowSize('xs', '<')
  const { ref } = anchorId ? useSmoothAnchorScroll(anchorId) : { ref: undefined }
  if (!accordions || !Array.isArray(accordions)) return null

  return (
    <>
      <div className={styles['accordion-group']} {...(anchorId ? { id: anchorId } : {})} ref={ref}>
        <Container className='container container--narrow-xxl'>
          {headline && (
            <Heading justify={isBelowBreakpointSm ? 'center' : 'left'} level={2}>
              <>{headline}</>
            </Heading>
          )}
          <div className={styles['accordion-group-content']}>
            {accordions.map((accordion, index) => {
              return (
                <Accordion
                  key={index}
                  title={accordion.title}
                  description={accordion.description}
                  anchorId={accordion.anchorId}
                />
              )
            })}
          </div>
        </Container>
      </div>
    </>
  )
}

export default AccordionGroup
